var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalCompleteTicket',{attrs:{"ticket":_vm.ticket,"solution_summary":_vm.solution_summary},on:{"changeStatusSuccess":function($event){return _vm.$emit('changeStatusSuccess', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }